import React, {Component} from 'react';
import {connect} from "react-redux";

import Discount from "./discount";
import DiscountAdd from "./discountAdd";
import DiscountSubTotal from "./discountSubTotal";
import {DISCOUNT_MAIN_TYPES, DISCOUNT_SECTION_TYPES} from "./discounstInterface";
import DiscountDeposit from "./discountDeposit";
import DiscountFinance from "./discountFinance";
import DiscountNestedParent from "./discountNestedParent";
import {discountSectionExistsInCurrentWizardSelections} from "./discountFunctions";


class PriceWorksheetList extends Component {

  render() {
    // const fabricatorSettings = this.props.fabricatorData.settings;
    return (
      <div className="discounts">
        {this.props.discountSections.map((discountSection, discountSectionIndex) => {
          if (discountSection.type === DISCOUNT_SECTION_TYPES.finance) {
            return null
          }
          if (!discountSectionExistsInCurrentWizardSelections(
            discountSection,
            this.props.allWizardsValues,
            this.props.activeQuoteIndex)
          ) {
            return null
          }
          const discounts = discountSection.discounts.filter((disc) => !disc.oldDeleted);
          return (
            <div key={discountSectionIndex} className={"discounts-section"}>
              <h3 className="scart-block__title">{discountSection.name}</h3>
              <ul className="discounts-list">
                {discounts.map((discount) => {
                  const key = discount.uuId || (discount.id + "-" + discount.order);
                  if (discount.discountType) {
                    switch (discount.discountType) {
                      case DISCOUNT_MAIN_TYPES.freeFill:
                        return <DiscountAdd key={key}
                                            discount={discount}
                                            discountSection={discountSection}/>
                      case DISCOUNT_MAIN_TYPES.subTotal:
                        return <DiscountSubTotal key={key}
                                                 discount={discount}
                                                 discountSection={discountSection}/>
                      case DISCOUNT_MAIN_TYPES.nested:
                        // child render is inside DiscountNestedParent
                        return discount.nestedParent ? null : <DiscountNestedParent key={key}
                                                                                    discount={discount}
                                                                                    discountSection={discountSection}/>
                      case DISCOUNT_MAIN_TYPES.finance:
                        return <DiscountFinance key={key}
                                                discount={discount}
                                                discountSection={discountSection}/>
                      case DISCOUNT_MAIN_TYPES.deposit:
                        return <DiscountDeposit key={key}
                                                discount={discount}
                                                discountSection={discountSection}/>
                      default:
                        return <Discount key={key}
                                         discount={discount}
                                         discountSection={discountSection}/>
                    }
                  }
                  // old support below
                  switch (true) {
                    case discount.isRidged:
                      return <DiscountAdd key={key}
                                           discount={discount}
                                           discountSection={discountSection}/>
                    case discount.isSubTotal:
                      return <DiscountSubTotal key={key}
                                               discount={discount}
                                               discountSection={discountSection}/>
                    default:
                      return <Discount key={key}
                                       discount={discount}
                                       discountSection={discountSection}/>
                  }
                })}
              </ul>
            </div>
          )
        })}
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  const {allWizardsValues} = store.wizardState;
  const {activeQuoteIndex} = store.quotesState;

  return {
    discountSections: store.priceWorksheetState.discountSections,
    fabricatorData: store.fabricatorState,
    allWizardsValues,
    activeQuoteIndex,
  };
};

export default connect(mapStateToProps, {

})(PriceWorksheetList);
